module.exports = "<div class=\"ml-2 mt-1\">\n    <ContentLoader :height=\"150\" :primaryColor=\"dtPalette['grey-3']\" >\n        <circle cx=\"100\" cy=\"75\" r=\"65\" />\n        <rect x=\"190\" y=\"40\" rx=\"5\" ry=\"5\" width=\"130\" height=\"25\" />\n        <rect x=\"190\" y=\"75\" rx=\"5\" ry=\"5\" width=\"300\" height=\"25\" />\n    </ContentLoader>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/containers/documents/loaders/document-categories-loader/template.html
// module id = /HuO
// module chunks = 0